import React from 'react';
import { AppSection, type Language } from '../types';
import { translations } from '../shared/i18n';

interface BottomNavProps {
  activeSection: AppSection;
  onSectionChange: (section: AppSection) => void;
  lang: Language;
}

const BottomNav: React.FC<BottomNavProps> = ({ activeSection, onSectionChange, lang }) => {
  const t = translations[lang];

  // Settings lives here rather than in the header: it now holds activation,
  // export and backup, which are destinations rather than a menu.
  const items: { section: AppSection; icon: string; label: string }[] = [
    { section: AppSection.DASHBOARD, icon: '🏠', label: t.dashboard },
    { section: AppSection.COMMAND, icon: '➕', label: t.newOrder },
    { section: AppSection.CLIENTS, icon: '👥', label: t.clients },
    { section: AppSection.PRODUCTS, icon: '📦', label: t.products },
    { section: AppSection.HISTORY, icon: '📜', label: t.history },
    { section: AppSection.ANALYTICS, icon: '📈', label: t.analytics },
    { section: AppSection.SETTINGS, icon: '⚙️', label: t.settings },
  ];

  return (
    <nav
      aria-label={t.appName}
      className="fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 h-16 flex items-center justify-around z-40 max-w-lg mx-auto"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      {items.map(({ section, icon, label }) => {
        const isActive = activeSection === section;
        return (
          <button
            key={section}
            onClick={() => onSectionChange(section)}
            aria-current={isActive ? 'page' : undefined}
            className={`flex flex-col items-center justify-center flex-1 h-full gap-0.5 transition-colors ${
              isActive ? 'text-[#C1272D]' : 'text-slate-400'
            }`}
          >
            <span className={`text-lg ${isActive ? '' : 'opacity-50'}`} aria-hidden="true">{icon}</span>
            <span className="text-[8px] font-extrabold uppercase tracking-wide">{label}</span>
          </button>
        );
      })}
    </nav>
  );
};

export default BottomNav;
